import { useEffect, useState } from 'react';

import { modifyQueryParams } from '@domains/pdp-common';

import { ImageObjectProps } from '../components/Image';

const getFileExtension = (file?: string | null) => {
  try {
    if (!file) return;

    return file.split('?')[0].split('.').pop();
  } catch (err) {
    console.error(err);
  }
};

interface useImageServiceProps {
  image: ImageObjectProps;
}

export const useImageService = ({ image }: useImageServiceProps) => {
  const [is_static, setIsStatic] = useState<boolean>(image.static_url !== null);
  const image_source = image.static_url ? image.static_url : '';
  const low_quality_params = {
    width: '400',
    height: '400',
    quality: '80',
    format: getFileExtension(image_source) === 'gif' ? 'jpeg' : 'webp',
  };
  const low_quality_image = modifyQueryParams(image_source, low_quality_params);
  const isStaticTriggerAvailable = () => {
    const urlPathArray = image.origin_url.split('.');
    return urlPathArray[urlPathArray.length - 1].includes('gif') && image.static_url && image.static_url.length > 0;
  };

  const is_gif = getFileExtension(image.url) === 'gif' && is_static;

  const handleToggle = () => {
    setIsStatic(!is_static);
  };

  return {
    image_source,
    low_quality_image,
    is_gif,
    is_static,
    low_quality_params,
    isStaticTriggerAvailable,
    handleToggle,
  };
};
